import type { FC } from 'react';

import S from './styles.module.scss';

interface IProductBadgeProps {
  /**
   * The text to display on the badge.
   */
  badgeText: string;
}

/**
 * A component to display a badge on the product display page.
 */
export const ProductBadge: FC<IProductBadgeProps> = ({ badgeText }) => {
  return <span className={S.container}>{badgeText}</span>;
};
